import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextCardio } from "./TextCardio";
import { SourcesCardio } from "./SourcesCardio";

export default function Cardio() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Cardio Panel' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Cardio Panel'

        content={<TextCardio />}

        sources={<SourcesCardio />}

/>

</>
)}